import { IKeyStringDict } from "@/types/GlobalTypes";

const VN: IKeyStringDict = {
	"language_code": "vn",
	"txt_language": "Ngôn ngữ",
	"txt_info": "Thông Tin",
	"txt_userid": "Tên đăng nhập",
	"txt_balance": "Số Dư",
	"txt_online_users": "Người Chơi Trực Tuyến",
	"txt_user": "Người Chơi",
	"txt_online": "Trực Tuyến",
	"txt_multitable": "Bảng",
	"txt_exit": "Thoát",
	"txt_tap_fullscreen": "Ấn Vào Để Xem Toàn Màn Hình",
	"txt_lost_connection_server": "Ngắt Kết Nối Với Máy Chủ, Xin Vui Lòng Làm Mới Lại Trình Duyệt.",
	"txt_no_how_to_play": "No how to play available for this game",
	"txt_no_data_available": "Không có dữ liệu",
	"txt_all_games": "Tất Cả Trò Chơi",
	"txt_favorites": "Ưa Thích",
	"txt_categories": "CATEGORIES",
	"txt_fast-tables_games": "FAST TABLE",
	"txt_dice_games": "TRÒ CHƠI VỚI XÚC XẮC",
	"txt_ball_games": "TRÒ CHƠI VỚI QUẢ BÓNG",
	"txt_casino_games": "TRÒ CHƠI CASINO",
	"txt_other_games": "CÁC TRÒ CHƠI KHÁC",
	"txt_game_name_m6": "24Dspin",
	"txt_game_name_m7": "Oglok",
	"txt_game_name_m8": "Dice 6",
	"txt_game_name_m10": "Head Tail",
	"txt_game_name_m11": "Red White",
	"txt_game_name_m13": "Billiards",
	"txt_game_name_m14": "Poker Dice",
	"txt_game_name_m16": "Gong Ball",
	"txt_game_name_m19": "Suwit",
	"txt_game_name_m20": "Monopoly",
	"txt_game_name_m21": "Monopoly World Cup",
	"txt_game_name_m22": "Baccarat",
	"txt_game_name_m23": "Dragon & Tiger",
	"txt_game_name_m24": "NiuNiu",
	"txt_game_name_m25": "FanTan",
	"txt_game_name_m27": "Shio Fights",
	"txt_game_name_m28": "IDN 4 Stand",
	"txt_game_name_m30": "5D",
	"txt_game_name_m32": "SamGong",
	"txt_game_name_m33": "Gong Ball Jitu",
	"txt_game_name_m34": "HILO",
	"txt_game_name_m35": "48D",
	"txt_game_name_m36": "36D",
	"txt_game_name_p6": "24D",
	"txt_game_name_p7": "Roulette",
	"txt_game_name_p9": "12D",
	"txt_game_name_p12": "Sicbo[Dice]",
	"txt_game_name_m26": "Race Ball",
	"txt_game_name_m29": "3D Shio",
	"txt_game_name_m31": "Sicbo Ball - Fast",
	"txt_game_name_p7b": "Roulette 2 - Fast Table",
	"txt_game_name_m17": "Toto Macau",
	"txt_game_name_m37": "Bingo Sicbo",
	"txt_game_name_m38": "Bingo Baccarat",
	"txt_game_name_m38b": "Bingo Baccarat 2",
	"txt_game_name_m39": "Duel Dice",
	"txt_game_name_m40": "Xoc Dia",
	"txt_game_name_m42": "Pinball",
	"txt_game_name_m50": "Toto Singapore",
	"txt_game_name_m51": "Toto Macau 5D",
	
	"txt_game_name_toto": "IDN Lotto",
	
	"txt_bet_closed": "Đóng Cược",
	"txt_roadmap": "Lộ Trình",
	"txt_history": "Lịch Sử",
	"txt_statistics": "Thống Kê",
	"txt_statistics_first": "STATISTICS 1ST BALL",
	"txt_show_all_roadmap": "Hiển Thị Tất Cả Bản Đồ",
	"txt_show_all_history": "Hiển Thị Tất Cả Lịch Sử",
	"txt_play_now": "Chơi Ngay",
	"txt_new_game_badge": "Mới",
	"txt_history_result": "Lịch Sử Kết Quả",
	"txt_history_win": "Lịch Sử Chiến Thắng",
	"txt_how_to_play": "Hướng Dẫn Cách Chơi",
	"txt_full_screen": "Toàn Màn Hình",
	"txt_total_bet": "Tất cả đặt cược",
	"txt_transaction": "Giao Dịch",
	"txt_news": "Tin Tức",
	"txt_settings": "Cài Đặt",
	"txt_promotions": "Khuyễn Mãi",
	"txt_new_game": "Trò Chơi Mới",
	"txt_new_features": "Các Tính Năng Mới",
	"txt_bonus_history": "Lịch Sử Tiền Thưởng",
	"txt_memo": "Bản Ghi Nhớ",
	"txt_referral": "Giới Thiệu",
	"txt_periode": "Mã Bàn",
	"txt_number": "Số",
	"txt_back": "Back",
	"txt_back_to_lobby_message": "Are you sure you want to go back to Lobby?",
	"txt_yes": "Yes",
	"txt_no": "No",
	"txt_transaction_history": "Lịch Sử Giao Dịch",
	"txt_result_history": "Lịch Sử Kết Quả",
	"txt_number_pagination": "Số.",
	"txt_date": "Ngày",
	"txt_status": "Trạng thái",
	"txt_debit": "Ghi Nợ",
	"txt_credit": "Tín Dụng",
	"txt_win": "Chiến Thắng",
	"txt_won": "Đã Thắng",
	"txt_lose": "Thua",
	"txt_buy": "Mua",
	"txt_refund": "Refund",
	"txt_bet": "Đặt Cược",
	"txt_guess": "Phỏng Đoán",
	"txt_prize": "Giải Thưởng",
	"txt_discount": "Giảm Giá",
	"txt_x_win": "X-Chiến Thắng",
	"txt_correction": "Correction",
	"txt_total_win": "Tổng Tiền Thắng",
	"txt_total": "Tổng",
	"txt_amount": "Số Tiền",
	"txt_type": "Kiểu",
	"txt_touch_to_close": "Chạm vào đây để đóng",
	"txt_all_odd": "All Odd",
	"txt_all_even": "All Even",
	"txt_all_low": "All Low",
	"txt_all_high": "All High",
	"txt_clear": "Clear",
	"txt_undo": "Undo",
	"txt_rebet": "Rebet",
	"txt_submit": "Submit",
	"txt_table_name": "Tên Bàn",
	"txt_bet_limit": "Giới Hạn Đặt Cược",
	"txt_min_number": "Số Tối Thiểu",
	"txt_max_number": "Số Tối Đa",
	"txt_min_50": "Tối Thiểu 50 - 50",
	"txt_max_50": "Tối Đa 50 - 50",
	"txt_table_information": "Table Information",
	"txt_toggle_streaming": "Toggle Streaming",
	"txt_wait_next_round": "Chờ Lượt Kế Tiếp",
	"txt_place_bet": "Đặt Cược",
	"txt_bet_close_in": "Đóng Cược",
	"txt_video_is_off_desktop_message": "Video is off\nGo to settings to turn on",
	"txt_video_is_off_mobile_message": "Video is off\nTap to turn on",
	"txt_loading_video": "Loading video...",
	"txt_odd_even": "Lẻ-Chẵn",
	"txt_odd": "Lẻ",
	"txt_even": "Chẵn",
	"txt_small_big": "Nhỏ-Lớn",
	"txt_small": "Nhỏ",
	"txt_big": "Lớn",
	"txt_detail": "Chi Tiết",
	"txt_red": "Đỏ",
	"txt_blue": "Xanh Dương",
	"txt_black": "Đen",
	"txt_white": "Trắng",
	"txt_head": "Đầu",
	"txt_tail": "Đuôi",
	"txt_banker": "Nhà Cái",
	"txt_player": "Người Chơi",
	"txt_result": "Phần Thưởng",
	"txt_any_double": "Bộ Đôi Bất Kỳ",
	"txt_any_triple": "Bộ Ba Bất Kỳ",
	"txt_triple": "Ba",
	"txt_one": "Một",
	"txt_two": "Hai",
	"txt_three": "Ba",
	"txt_four": "Bốn",
	"txt_five": "Năm",
	"txt_six": "Sáu",
	"txt_seven": "Bảy",
	"txt_eight": "Tám",
	"txt_nine": "Chín",
	"txt_ten": "Mười",
	"txt_balls_passed_line": "Balls passed line",
	"txt_balls": "ball(s)",
	"txt_on_one_dice": "Trên Một Xúc Xắc",
	"txt_on_two_dice": "Trên Hai Con Xúc Xắc",
	"txt_on_three_dice": "Trên Ba Con Xúc Xắc",
	"txt_shrimp": "Tôm",
	"txt_chicken": "Gà",
	"txt_jug": "Bầu",
	"txt_crab": "Cua",
	"txt_fish": "Cá",
	"txt_2_pairs": "2 Đôi",
	"txt_3_of_a_kind": "Sám Cô",
	"txt_inc_straight": "Sảnh Ngắt Quãng",
	"txt_flush": "Đồng Chất",
	"txt_full_house": "Cù Lũ",
	"txt_straight": "Sảnh",
	"txt_4_of_a_kind": "4 Xúc Xắc\nGiống Nhau",
	"txt_inc_straight_flush": "Sảnh Đồng Chất\nNgắt Quãng",
	"txt_straight_flush": "Sảnh Đồng Chất",
	"txt_5_of_a_kind": "5 Xúc Xắc\nGiống Nhau",
	"txt_line": "Hàng",
	"txt_row": "Hàng",
	"txt_1st_line": "Hàng 1",
	"txt_2nd_line": "Hàng 2",
	"txt_3rd_line": "Hàng 3",
	"txt_4th_line": "Hàng 4",
	"txt_5th_line": "Hàng 5",
	"txt_6th_line": "Hàng 6",
	"txt_7th_line": "Hàng 7",
	"txt_8th_line": "Hàng 8",
	"txt_9th_line": "Hàng 9",
	"txt_10th_line": "Hàng 10",
	"txt_1st_row": "Hàng 1",
	"txt_2nd_row": "Hàng 2",
	"txt_3rd_row": "Hàng 3",
	"txt_4th_row": "Hàng 4",
	"txt_2_to_1": "2 Đến 1",
	"txt_1st_2nd_line": "Hàng 1 Và Hàng 2",
	"txt_2nd_3rd_line": "Hàng 2 Và Hàng 3",
	"txt_3rd_4th_line": "Hàng 3 Và Hàng 4",
	"txt_4th_5th_line": "Hàng 4 Và Hàng 5",
	"txt_5th_6th_line": "Hàng 5 Và Hàng 6",
	"txt_1st_line_2nd_line": "Hàng 1 Và Hàng 2",
	"txt_3rd_line_4th_line": "Hàng 3 Và Hàng 4",
	"txt_1_to_18": "1 Đến 18",
	"txt_19_to_36": "19 Đến 36",
	"txt_left": "Trái",
	"txt_right": "Phải",
	"txt_key": "Chi Phí",
	"txt_coin": "Đồng Xu",
	"txt_jackpot": "JP",
	"txt_pictures": "Hình Ảnh",
	"txt_square": "Hình Vuông",
	"txt_circle": "Vòng Tròn",
	"txt_others": "Khác",
	"txt_either_pair": "Cặp Đôi",
	"txt_player_pair": "Người Chơi Đôi",
	"txt_perfect_pair": "Cặp Đôi Cùng Chất",
	"txt_banker_pair": "Nhà Cái Đôi",
	"txt_tie": "Hòa",
	"txt_tie_on": "Tie On",
	"txt_dice": "Dice",
	"txt_shoe": "Hộp Đựng Bài",
	"txt_round_id": "Mã Vòng Xoay",
	"txt_new_shoe_message": "New Shoe in progress\nPlease wait",
	"txt_less_bet": "Less Bet",
	"txt_more_bet": "More Bet",
	"txt_sounds": "Âm Thanh",
	"txt_music": "Âm Nhạc",
	"txt_auto_confirm_bet": "Tự Động Xác Nhận Đặt Cược",
	"txt_auto_rebet": "Tự Động Đặt Cược Lại",
	"txt_video": "Video",
	"txt_enable_rotation": "Bật Tính Năng Xoay",
	"txt_batu": "Búa",
	"txt_gunting": "Kéo",
	"txt_kertas": "Bao",
	"txt_jempol": "Ngón Cái",
	"txt_telunjuk": "Ngón Trỏ",
	"txt_kelingking": "Ngón Út",
	"txt_rat": "rat",
	"txt_ox": "ox",
	"txt_tiger": "tiger",
	"txt_rabbit": "rabbit",
	"txt_dragon": "dragon",
	"txt_snake": "snake",
	"txt_horse": "horse",
	"txt_goat": "goat",
	"txt_monkey": "monkey",
	"txt_rooster": "rooster",
	"txt_dog": "dog",
	"txt_pig": "pig",
	"txt_tickets": "TICKETS",
	"txt_remove_unwanted_tickets": "Please remove the unwanted tickets before submitting.",
	"txt_submit_to_confirm_rebet": "Click Submit button to confirm Rebet.",
	"txt_no_tickets": "You have no running tickets.",
	"txt_running_tickets": "RUNNING TICKETS",
	"txt_choose_bet_type": "Choose bet type to start.",
	"txt_place_bet_amount": "Please place your bet amount first.",
	"txt_add_tickets": "Add Tickets",
	"txt_choose_bet_type_message": "Please choose Bet Type to start.",
	"txt_remove_unwanted_ticket_message": "Please remove the unwanted tickets before submitting.\nClick Submit button to confirm rebet.",
	"txt_rebet_ticket_message": "You still have rebet tickets!\nTouch \"Show\" to see, then touch Submit to send your bets.",
	"txt_drawing_result": "Drawing Result",
	"txt_m29_first": "First",
	"txt_m29_middle": "Middle",
	"txt_m29_last": "Last",
	"txt_3_pictures": "3 Pictures",
	"txt_any_pictures": "Any Pictures",
	"txt_either_3_picture": "Either 3 Picture",
	"txt_either_any_picture": "Either Any Picture",

	//Gong Ball Jitu
	"txt_gbj_result_message": "To view the live result for the GONG BALL JITU game,  please refer to the GongBall board (left side) on the live streaming.",

	"txt_popup_streaming_quality": "Please change streaming quality to HD here",

	"txt_action": "Hoạt động",

	// bet panel m39
	"txt_m39_red": "Red",
	"txt_m39_blue": "Blue",
	"txt_m39_tie": "Tie",
	"txt_m39_odd": "Odd",
	"txt_m39_even": "Even",
	"txt_m39_low": "Low",
	"txt_m39_high": "High",
	"txt_m39_Odd/Even": "Odd/Even", 
	"txt_m39_Odd/Odd": "Odd/Odd", 
	"txt_m39_Even/Odd": "Even/Odd", 
	"txt_m39_Even/Even": "Even/Even",
	"txt_m39_Low/High": "Low/High", 
	"txt_m39_Low/Low": "Low/Low", 
	"txt_m39_High/Low": "High/Low", 
	"txt_m39_High/High": "High/High",

	// htp m17
	"txt_m17_out-number": "Out Number",
	"txt_m17_4D/3D/2D": "4D/3D/2D",
	"txt_m17_free-plug": "Free Plug",
	"txt_m17_2D-free-plug": "2D Free Plug",
	"txt_m17_plug-dragon": "Plug Dragon",
	"txt_m17_plug-it-in": "Plug it in",
	"txt_m17_middle-edge": "Middle Edge",
	"txt_m17_combination": "Combination", 
	"txt_m17_base": "Base",
	"txt_m17_50-50": "50-50",
	"txt_m17_shio": "Shio",
	"txt_m17_cross": "Cross",
	"txt_m17_flaming-flower": "Flaming Flower",

	// how to play
	"txt_htp_intro": "GIỚI THIỆU",
	"txt_htp_rules": "LUẬT CHƠI",
	"txt_htp_placing-bet": "ĐẶT CƯỢC",
	"txt_htp_bet-desc": "MÔ TẢ & VÍ DỤ ĐẶT CƯỢC",
    "txt_htp_payout": "THANH TOÁN",
	"txt_htp_rank": "XẾP HẠNG",
	"txt_complete_information": "DETAILED INFORMATION"
};

export default VN;